import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  isDevMode,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

import { AlertService } from 'src/app/services/alert.service';
import { OrganizationsService } from 'src/app/services/organizations.service';
import { IOrganization } from 'src/app/models/organizations/organization';
import { OrganizationResult } from 'src/app/models/organizations/organization-result';
import { OrganizationUpdateModel } from 'src/app/models/organizations/organization-update';

@Component({
  selector: 'app-organization-shopify-sync',
  templateUrl: './organization-shopify-sync.component.html',
  styleUrls: ['./organization-shopify-sync.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class OrganizationShopifySyncComponent implements OnChanges {
  @Input({ required: true }) organization!: IOrganization;
  @Output() saved = new EventEmitter<IOrganization>();

  private readonly destroy$ = new Subject<void>();
  readonly shopifyFormControl: FormControl = new FormControl();
  requestInProgress: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['organization'] && this.organization) {
      this.shopifyFormControl.setValue(this.organization.shopifyHostDomain);
    }
  }

  saveShopifyDomain(): void {
    this.requestInProgress = true;
    const payload: OrganizationUpdateModel = {
      name: this.organization.name,
      shopifyHostDomain: this.shopifyFormControl.value,
      version: this.organization.version,
    };

    this.organizationsService
      .updateOrganization(this.organization.id!, payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result: OrganizationResult) => {
          if (isDevMode()) {
            console.log('[DEV] [OrganizationShopifySyncComponent] result', result);
          }
          this.requestInProgress = false;
          this.alertService.successToast('Successful update');
          this.saved.emit(result.organization);
        },
        error: () => {
          this.requestInProgress = false;
        },
      });
  }

  shopifyLogin(): void {
    this.organizationsService
      .shopifyLogin(this.organization.id!)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: string) => {
        console.debug('authorization login: ', result);
        window.open(result, '_blank');
      });
  }

  constructor(
    private organizationsService: OrganizationsService,
    private alertService: AlertService,
  ) {}
}
